import { icons } from '@/Icons';
import {
	ModalStatusEnum,
	useLogout,
	useModalStoreActions,
	usePrivyStoreActions,
	useUserStoreActions,
	useVipActions,
} from '@/store';
import { redirect } from 'next/navigation';

export const useData = () => {
	const logout = useLogout();
	const { resetPrivyStore } = usePrivyStoreActions();
	const { resetUserStore } = useUserStoreActions();
	const { setModalStatus } = useModalStoreActions();
	const { resetVipStore } = useVipActions();
	const data = {
		links: [
			{
				title: 'My Account',
				link: '/account?type=profile',
				icon: <icons.profile />,
			},
			{
				title: 'Wallet',
				function: () => {
					setModalStatus(ModalStatusEnum.WalletModal);
				},
				icon: <icons.wallet />,
			},
			{
				title: 'Transactions',
				link: '/account?type=transactions',
				icon: <icons.transactions />,
			},
			{
				title: 'Redeem Code',
				function: () => {
					setModalStatus(ModalStatusEnum.RedeemPromoModal);
				},
				icon: <icons.redeemcode />,
			},
			{
				title: 'Affilates',
				link: 'https://www.otherworldaffiliates.com/',
				icon: <icons.affiliates />,
			},
			{
				title: 'Settings',
				link: '/account?type=profile',
				icon: <icons.settings />,
			},
		],
		logout: {
			title: 'Logout',
			function: () => {
				logout();
				resetPrivyStore();
				resetUserStore();
				resetVipStore();
				redirect('/');
			},
			icon: <icons.logout />,
		},
	};
	return { data };
};
export default useData;
